"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthenticatedStatus = exports.AuthenticatedStatus = void 0;
const react_1 = __importDefault(require("react"));
const faUserCircle_1 = require("@fortawesome/pro-solid-svg-icons/faUserCircle");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const Container_1 = __importDefault(require("../../Container"));
const Navigation_1 = __importDefault(require("../../Navigation"));
const NavigationLink_1 = __importDefault(require("../../NavigationLink"));
const Link_1 = __importDefault(require("../../Link"));
const constants_1 = require("../../../utils/constants");
const navigation_1 = require("../../../interfaces/navigation");
const analyticsUtils_1 = require("../../../utils/analyticsUtils");
const testUtils_1 = require("../../../utils/testUtils");
const styles = require('./HeaderDesktop.module.scss');
const AuthenticatedStatus = ({ accountLink, name, }) => (react_1.default.createElement("span", { className: styles.whiteSpaceNoWrap },
    react_1.default.createElement(Link_1.default, Object.assign({ color: "black", href: accountLink, className: styles.authenticatedLink, trackingAttributes: {
            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
            action: 'click',
            label: 'username',
        } }, (0, testUtils_1.getDataTypeAttribute)({ typeId: 'header-auth-account' })),
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faUserCircle_1.faUserCircle, className: styles.authenticatedIcon }),
        react_1.default.createElement("span", { className: styles.userName }, name))));
exports.AuthenticatedStatus = AuthenticatedStatus;
const UnauthenticatedStatus = ({ loginLink, registerLink, }) => (react_1.default.createElement("span", { className: styles.whiteSpaceNoWrap },
    react_1.default.createElement(Link_1.default, Object.assign({ color: "black", href: loginLink, trackingAttributes: {
            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
            action: 'click',
            label: 'login',
        } }, (0, testUtils_1.getDataTypeAttribute)({ typeId: 'header-auth-login' })), "Sign in"),
    react_1.default.createElement("span", null, " or "),
    react_1.default.createElement(Link_1.default, Object.assign({ color: "black", href: registerLink, trackingAttributes: {
            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
            action: 'click',
            label: 'register',
        } }, (0, testUtils_1.getDataTypeAttribute)({ typeId: 'header-auth-register' })), "Register")));
exports.UnauthenticatedStatus = UnauthenticatedStatus;
const HeaderDesktop = ({ accountLink, displayUserStatus, isAuthenticated, loginLink, logoutLink, nodes, registerLink, userName, }) => (react_1.default.createElement("div", { className: styles.header },
    react_1.default.createElement("div", { className: styles.underline },
        react_1.default.createElement(Container_1.default, null,
            react_1.default.createElement("div", { className: styles.topRow },
                react_1.default.createElement(Link_1.default, { trackingAttributes: {
                        action: navigation_1.AnalyticsActionHeaderType.Logo,
                        category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    }, href: `/${constants_1.Pages.Homepage}` },
                    react_1.default.createElement("img", { alt: "PistonHeads", src: "/static-assets/images/logo-smiley-with-text.17112021.svg", className: styles.logo })),
                react_1.default.createElement(Navigation_1.default, null, nodes.map((node) => {
                    const { action, category, path, rel, text, type, hideDesktop } = node;
                    if (hideDesktop) {
                        return undefined;
                    }
                    return (react_1.default.createElement(NavigationLink_1.default, Object.assign({ href: path, key: type, rel: rel, type: type, node: node }, (0, analyticsUtils_1.getTrackingAttributes)({ action, category }), (0, testUtils_1.getDataTypeAttribute)({ typeId: `header-nav-link-${type.toLowerCase()}` })), text));
                })),
                react_1.default.createElement("div", { className: styles.userStatus }, displayUserStatus &&
                    (isAuthenticated ? (react_1.default.createElement(exports.AuthenticatedStatus, { name: userName, logoutLink: logoutLink, accountLink: accountLink })) : (react_1.default.createElement(exports.UnauthenticatedStatus, { loginLink: loginLink, registerLink: registerLink })))))))));
exports.default = HeaderDesktop;
//# sourceMappingURL=HeaderDesktop.js.map